import { phuongXa } from "@/store/modules/shareData/phuongXa"

const newModel = () => {
    return {
        lichThugomracId: null,
        phuongXaId: null,
        tenPhuongXa: null,
        tuyenduongThugomracId: null,
        tenTuyenduongThugomrac: null,
        diabanThugomracId: null,
        tenDiabanThugomrac: null,
        thoigianThuchien: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        lichThugomracId: null,
        phuongXaId: null,
        tuyenduongThugomracId: null,
        diabanThugomracId: null,
        thoigianThuchien: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        lichThugomracId: item.lichThugomracId,
        phuongXaId: item.phuongXaId,
        tenPhuongXa: item.tenPhuongXa,
        tuyenduongThugomracId: item.tuyenduongThugomracId,
        tenTuyenduongThugomrac: item.tenTuyenduongThugomrac,
        diabanThugomracId: item.diabanThugomracId,
        tenDiabanThugomrac: item.tenDiabanThugomrac,
        thoigianThuchien: item.thoigianThuchien,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        lichThugomracId: item.lichThugomracId,
        phuongXaId: item.phuongXaId,
        tuyenduongThugomracId: item.tuyenduongThugomracId,
        tenTuyenduongThugomrac: item.tenTuyenduongThugomrac,
        diabanThugomracId: item.diabanThugomracId,
        tenDiabanThugomrac: item.tenDiabanThugomrac,
        thoigianThuchien: item.thoigianThuchien,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        lichThugomracId: null,
        phuongXaId: null,
        tuyenduongThugomracId: null,
        diabanThugomracId: null,
        thoigianThuchien: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        lichThugomracId: item.lichThugomracId,
        phuongXaId: item.phuongXaId,
        tuyenduongThugomracId: item.tuyenduongThugomracId,
        diabanThugomracId: item.diabanThugomracId,
        thoigianThuchien: item.thoigianThuchien,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        lichThugomracId: null,
        phuongXaId: null,
        tuyenduongThugomracId: null,
        diabanThugomracId: null,
        thoigianThuchien: null,
        stt: null,
        enabled: null,
    }
}

export const lichThugomracModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


